const SocketEvent = {
  INITIATE_UNIFICATION_EVENT_NAME: 'Data Unification',

  INPUT_SYNC_EVENT_NAME: 'Transaction Source Data Upload',
  MASTER_SYNC_EVENT_NAME: 'Master Source Data Upload',

  START_CALCULATION_EVENT_NAME: 'Payout Calculation',

  NUDGE_EVENT_NAME: 'Nudge Trigger',
  TASK_CREATION_PROGRESS: 'TASK_CREATION_PROGRESS',

  TASK_APPROVAL: 'Auto-Authorized',
  TASK_REMINDER: 'Pending Authorization',
  TASK_ESCALATION: 'Follow-up Notice',
};

export default SocketEvent;
